import Search, { updateSortOptions, updateGridView, updateDom, appendDataLayer, parseResults } from '@assets/search/search';
import listner from '../../utils/listener';
import { updateURLWithSize, updateURLWithFilters } from '@assets/utils/history';
import scrollAnimate from '@assets/components/scrollAnimate';

import QuickView from '../product/quickView';

document.addEventListener('DOMContentLoaded', (e) => {
  new QuickView().init();
});

export default class extends Search {
  constructor() {
    super();
    this.currentViewMode = null;
    this.viewportChanged = false;
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    this.resolutions = {
      large: 1280,
      medium: 768,
      small: 360
    };
    // eslint-disable-next-line no-unneeded-ternary
    this.isMobile = window.innerWidth > this.resolutions.medium ? false : true;
    this.handleToggleFilters();
    this.handleGridView();
    this.handleDataLayer();
    this.brandSearchField();
  }

  init() {
    super.init();
    this.refinementsHeight = $('.refinements').innerHeight();
    this.refinementsBarHeight = $('.desktop-sticky-side').innerHeight();
    this.refinementsBarOffset = $('.desktop-sticky-side').offset().top;
    this.getRefinementsHeight(this.refinementsHeight, this.refinementsBarHeight, this.refinementsBarOffset);
    window.addEventListener(
      'resize',
      this.getRefinementsHeight.bind(this, this.refinementsHeight, this.refinementsBarHeight, this.refinementsBarOffset)
    );
    window.addEventListener(
      'scroll',
      this.getRefinementsHeight.bind(this, this.refinementsHeight, this.refinementsBarHeight, this.refinementsBarOffset)
    );
    window.addEventListener('resize', this.resize.bind(this, window));
  }

  handleToggleFilters() {
    $('body').on('click', '.card-header .btn', (e) => {
      const $this = $(e.currentTarget);
      const target = $this.attr('aria-controls');

      $this.parents('.refinement').toggleClass('active');
      $(`#${target}`).stop().slideToggle(300);
    });
  }

  handleGridView() {
    const $container = $('.product-grid');
    const sessionStorageView = sessionStorage.getItem('product-list-view');

    if (!sessionStorageView) {
      sessionStorage.setItem('product-list-view', 'single-view');
    }

    this.updateDataViewStyle($container, sessionStorageView);

    $(document).on('click', '.btn-action-grid', function () {
      const $this = $(this);
      $this.addClass('active');
      $this.siblings('.btn-action-grid').removeClass('active');
      sessionStorage.setItem('product-list-view', $this.hasClass('grid-view') ? 'grid-view' : 'single-view');

      if ($this.hasClass('grid-view')) {
        $container.removeClass('single-view').addClass('grid-view');
        $container.find('.product-tile-render').removeClass('col-12 col-sm-12').addClass('col-6 col-sm-6');
      } else if ($this.hasClass('single-view')) {
        $container.removeClass('grid-view').addClass('single-view');
        $container.find('.product-tile-render').removeClass('col-6 col-sm-6').addClass('col-12 col-sm-12');
      }
    });
  }

  updateDataViewStyle($container, sessionStorageView) {
    const container = $container || $('.product-grid');
    const sessionStorage = sessionStorageView || window.sessionStorage.getItem('product-list-view');

    if (!sessionStorage) {
      sessionStorage.setItem('product-list-view', 'single-view');
    }

    if (!sessionStorage || sessionStorage === 'single-view') {
      $('.btn-action-grid.single-view').addClass('active');
      $('.btn-action-grid.grid-view').removeClass('active');
      container.removeClass('grid-view').addClass('single-view');
      container.find('.product-tile-render').removeClass('col-6 col-sm-6').addClass('col-12 col-sm-12');
      this.currentViewMode = 'single-view';
    } else if (sessionStorage === 'grid-view') {
      $('.btn-action-grid.grid-view').addClass('active');
      $('.btn-action-grid.single-view').removeClass('active');
      container.removeClass('single-view').addClass('grid-view');
      container.find('.product-tile-render').removeClass('col-12 col-sm-12').addClass('col-6 col-sm-6');
      this.currentViewMode = 'grid-view';
    }
  }

  handleDataLayer() {
    const $grid = $('.product-grid');
    const impressions = [];
    const category = [];

    $('.breadcrumb-item:not(:first)').each((index, elem) => {
      category.push($.trim($(elem).children().text()));
    });

    $grid.find('.product').each((index, element) => {
      const dataLayerImpression = {
        name: $(element).attr('data-name'),
        id: $(element).attr('data-id'),
        price: $(element).attr('data-price'),
        brand: $(element).attr('data-brand'),
        category: $(element).attr('data-category'),
        position: index + 1
      };

      for (let i = 0; i < category.length; i++) {
        dataLayerImpression['item_category' + (i > 0 ? i + 1 : '')] = category[i];
      }

      impressions.push(dataLayerImpression);
    });

    if (dataLayer) {
      dataLayer.push({
        ecommerce: {
          currencyCode: $grid.find('.product').first().attr('data-currency'),
          impressions: impressions
        }
      });

      listner.dataLayerAddToCartHandler(category);
    }
  }

  setNewFeedatyWidgets() {
    // eslint-disable-next-line no-undef
    if (FeedatyWidget) {
      // eslint-disable-next-line no-undef
      FeedatyWidget.firstLoad = true;
      // eslint-disable-next-line no-undef
      FeedatyWidget.init();
      // eslint-disable-next-line no-undef
      FeedatyWidget.firstLoad = false;
    }
  }

  handleMultipleSortingDropdownValues($dropdownChanged) {
    const $dropdownToUpdate =
      $dropdownChanged.parents('.desktop-sticky-side').length > 0
        ? $('.sort-results-container-desktop-top').find('select')
        : $('.desktop-sticky-side').find('select');

    const newValue = $dropdownChanged.val();

    // set all options as unselected
    $dropdownToUpdate.find('option').prop('selected', false);
    // select only the correct option
    $dropdownToUpdate.find('option[value="' + newValue + '"]').prop('selected', true);
  }

  showMore() {
    // Show more products
    const _this = this;

    $('.container').on('click', '.show-more button', function (e) {
      e.stopPropagation();
      e.preventDefault();

      const $this = $(this);
      const $grid = $('.product-grid');
      const position = $grid.find('.product').length;

      const url = $this.data('url');
      const newUrl = updateURLWithSize(window.location.href, url);

      $this.spinner().start();
      $this.addClass('loading').trigger('search:showMore', e);
      $.ajax({
        url: url,
        data: { selectedUrl: url },
        method: 'GET',
        success(response) {
          $this.removeClass('loading');
          $('.grid-footer').replaceWith(response);
          updateSortOptions(response);
          updateGridView($('.product-grid'));
          appendDataLayer(response, $grid, position);
          // @for back-button
          window.history.replaceState({}, '', newUrl);

          _this.setNewFeedatyWidgets();

          $.spinner().stop();
        },
        error() {
          $.spinner().stop();
        }
      });
    });
  }

  applyFilter() {
    // Handle refinement value selection and reset click
    const _this = this;

    $('.container').on(
      'click',
      '.refinements li button:not(.selected), .refinement-bar button.reset, .filter-value button, .swatch-filter button, .selected-filter',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        const url = $(this).data('href');
        const newUrl = updateURLWithFilters(
          $(this).hasClass('category-refinement-button') && !url.includes('?q=') ? $(this).data('absurl') : window.location.href,
          url
        );
        $.spinner().start();
        $(this).trigger('search:filter', e);
        $.ajax({
          url: url,
          data: {
            page: 1,
            selectedUrl: url
          },
          method: 'GET',
          success(response) {
            parseResults(response);
            updateGridView($('.product-grid'));
            updateDom($(response), '.selected-filters');
            updateSortOptions(response);
            _this.sort(); // reinitialize listeners for filters and sortng

            const dataPageTitle = $('.result-count').attr('data-page-title');
            if (dataPageTitle !== 'null') {
              $('title').html(dataPageTitle);
            }
            // @for back-button
            window.history.replaceState({}, '', newUrl);

            _this.setNewFeedatyWidgets();

            $.spinner().stop();
          },
          complete() {
            scrollAnimate();
          },
          error() {
            $.spinner().stop();
          }
        });
      }
    );
  }

  sort() {
    // Handle sort order menu selection
    const _this = this;

    $('.container').on('change', '[name=sort-order]', function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.handleMultipleSortingDropdownValues($(this));
      const newUrl = updateURLWithFilters(window.location.href, this.value);
      $.spinner().start();
      $(this).trigger('search:sort', this.value);
      $.ajax({
        url: this.value,
        data: { selectedUrl: this.value },
        method: 'GET',
        success(response) {
          $('.product-grid').empty().html(response);
          updateGridView($('.product-grid'));
          // @for back-button
          window.history.replaceState({}, '', newUrl);

          _this.setNewFeedatyWidgets();

          $.spinner().stop();
        },
        error() {
          $.spinner().stop();
        }
      });
    });

    $('.selected-filter').on('mouseenter', function (e) {
      $(e.currentTarget).find('.isicon--icon-check-green').addClass('d-none');
      $(e.currentTarget).find('.isicon--icon-close-new').removeClass('d-none');
    });

    $('.selected-filter').on('mouseleave', function (e) {
      $(e.currentTarget).find('.isicon--icon-check-green').removeClass('d-none');
      $(e.currentTarget).find('.isicon--icon-close-new').addClass('d-none');
    });
  }

  /**
   * Resize Handler
   */
  resize(win) {
    const ww = win.innerWidth;
    const wh = win.innerHeight;

    if (this.screenWidth !== ww || this.screenHeight !== wh) {
      this.screenHeight = wh;
      this.screenWidth = ww;

      if (this.viewportChanged === false && this.isMobile && this.screenWidth > this.resolutions.medium) {
        this.isMobile = false;
        this.viewportChanged = true;
      }

      if (this.viewportChanged === false && !this.isMobile && this.screenWidth <= this.resolutions.medium) {
        this.isMobile = true;
        this.viewportChanged = true;
      }

      if (this.viewportChanged === true) {
        if (this.isMobile) {
          this.updateDataViewStyle();
        }

        this.viewportChanged = false;
      }
    }
  }

  getRefinementsHeight(refinementsHeight, refinementsBarHeight, refinementsBarOffset) {
    /* only for desktop version, in mobile refinements are managed in different way */
    $('.refinements').css({ height: 'auto', 'overflow-y': 'unset' });
  }

  brandSearchField() {
    $('.search-brand input').on('input', function () {
      const filter = $(this).val().toLowerCase();
      const brands = $('.brand-list li .selectable');

      for (let i = 0; i < brands.length; i++) {
        const brand = brands[i].getAttribute('data-label');

        if (brand.indexOf(filter) > -1) {
          brands[i].style.display = '';
        } else {
          brands[i].style.display = 'none';
        }
      }
    });
  }
}
